// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".materials-scanner-scan{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%}.materials-scanner-scan--image{width:460px}.materials-scanner-scan--modal>.vm--modal>.v-modal--content>.modal-layout>.modal-layout--content{padding:0!important}", ""]);
// Exports
module.exports = exports;
